import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import { amber, blue, blueGrey, cyan, deepOrange, deepPurple, green, indigo, lightBlue, lightGreen, lime, orange, pink, purple, red, teal, yellow } from '@material-ui/core/colors';

const styles = theme => ({
    paper: {
        padding: '6px 16px',
    },
    secondaryTail: {
        backgroundColor: theme.palette.secondary.main,
    },
    darkRed: {
        color: theme.palette.getContrastText(red[900]),
        backgroundColor: red[900],
    },
    deepOrange: {
          color: theme.palette.getContrastText(deepOrange[500]),
          backgroundColor: deepOrange[500],
      },
      deepPurple: {
          color: theme.palette.getContrastText(deepPurple[500]),
          backgroundColor: deepPurple[500],
      },
      lightPurple: {
          color: theme.palette.getContrastText(deepPurple[200]),
          backgroundColor: deepPurple[200],
      },
      orange: {
          color: theme.palette.getContrastText(orange[500]),
          backgroundColor: orange[500],
      },
      purple: {
          color: theme.palette.getContrastText(purple[500]),
          backgroundColor: purple[500],
      },
      indigo: {
          color: theme.palette.getContrastText(indigo[500]),
          backgroundColor: indigo[500],
      },
      lightIndigo: {
          color: theme.palette.getContrastText(indigo[200]),
          backgroundColor: indigo[200],
      },
      lightBlue: {
          color: theme.palette.getContrastText(blue[100]),
          backgroundColor: blue[100],
      },
      cyan: {
          color: theme.palette.getContrastText(cyan[500]),
          backgroundColor: cyan[500],
      },
      lightCyan: {
          color: theme.palette.getContrastText(cyan[200]),
          backgroundColor: cyan[200],
      },
      teal: {
          color: theme.palette.getContrastText(teal[500]),
          backgroundColor: teal[500],
      },
      green: {
          color: theme.palette.getContrastText(green[500]),
          backgroundColor: green[500],
      },
      lightGreen: {
          color: theme.palette.getContrastText(lightGreen[500]),
          backgroundColor: lightGreen[500],
      },
      lime: {
          color: theme.palette.getContrastText(lime[500]),
          backgroundColor: lime[500],
      },
      yellow: {
          color: theme.palette.getContrastText(yellow[500]),
          backgroundColor: yellow[500],
      },
      lightYellow: {
          color: theme.palette.getContrastText(yellow[50]),
          backgroundColor: yellow[50],
      },
      amber: {
          color: theme.palette.getContrastText(amber[500]),
          backgroundColor: amber[500],
      },
      lightAmber: {
          color: theme.palette.getContrastText(amber[200]),
          backgroundColor: amber[200],
      },
      blueGrey: {
          color: theme.palette.getContrastText(blueGrey[500]),
          backgroundColor: blueGrey[500],
      },
      lightBlueGrey: {
          color: theme.palette.getContrastText(blueGrey[100]),
          backgroundColor: blueGrey[100],
      },
      blue: {
          color: theme.palette.getContrastText(blue[500]),
          backgroundColor: blue[500],
      },
      pink: {
          color: theme.palette.getContrastText(pink[500]),
          backgroundColor: pink[500],
      },
      lightPink: {
          color: theme.palette.getContrastText(pink[50]),
          backgroundColor: pink[50],
      },
      darkPink: {
          color: theme.palette.getContrastText(pink[900]),
          backgroundColor: pink[900],
      },
      red: {
          color: theme.palette.getContrastText(red[500]),
          backgroundColor: red[500],
      },
      lightRed: {
          color: theme.palette.getContrastText(red[200]),
          backgroundColor: red[200],
      },
      darkError: {
          color: theme.palette.getContrastText(red[200]),
          backgroundColor: red[200],
      },
      error: {
          color: theme.palette.getContrastText(red[100]),
          backgroundColor: red[100],
      },
      danger: {
          color: theme.palette.getContrastText(red[100]),
          backgroundColor: red[100],
      },
      info: {
          color: theme.palette.getContrastText(lightBlue[100]),
          backgroundColor: lightBlue[100],
      },
      warning: {
          color: theme.palette.getContrastText(orange[100]),
          backgroundColor: orange[100],
      },
      success: {
          color: theme.palette.getContrastText(teal[100]),
          backgroundColor: teal[100],
      },
      primary: {
          color: theme.palette.getContrastText(theme.palette.primary.light),
          backgroundColor: theme.palette.primary.light,
      },
  });
  

class Item extends Component {
    render(){
        const { step, classes, CLASSES } = this.props;
        console.log('====================================');
        console.log({step, classes});
        console.log('====================================');
        console.log(this.props);
        return(
            <TimelineItem>
                <TimelineOppositeContent style={{ flex: "0.2"}}>
                    <Typography variant="subtitle1">{step.date}</Typography>
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot className={classes[step.color] || "primary"}>
                    {/* <TimelineDot style={{ backgroundColor: color}}> */}
                        {step.icon}
                    </TimelineDot>
                    <TimelineConnector className={classes.secondaryTail} />
                </TimelineSeparator>
                <TimelineContent>
                    <Paper elevation={2} className={classes.paper}>
                    {/* <Paper elevation={2} className={classes.paper}> */}
                        <Box p={1}>
                            {/* <Typography variant="subtitle1" color="textSecondary">
                                {step.date}
                            </Typography> */}
                            <Typography variant="h6">
                                {step.title}
                            </Typography>
                            <Typography>{step.content}</Typography>
                            <Typography>{step.other}</Typography>
                        </Box>
                    </Paper>
                </TimelineContent>
            </TimelineItem>
        )
    }
}

const TimeLineBlock =  withStyles(styles)(Item);
export { TimeLineBlock }


class TimeLineMUI extends Component {


    render(){
        const { list } = this.props;
        return (
            <Timeline>
                {list.map( step => <TimeLineBlock step={step} />)}
            </Timeline>
        )
    }

  
}

export default withStyles(styles)(TimeLineMUI)